import React, { useEffect, useState, useMemo } from 'react'
import { MdClose, MdDelete, MdEdit } from 'react-icons/md';
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom';
import Header from '../components/header';
import AppLayout from '../components/AppLayout';
import { deleteTemplates, editTemplates, editTemplatesByBusiness, getTemplates, getTemplatesByBusiness } from '../logic/customTemplates/action';
import { getPlan } from '../logic/plans/action';
import { Button, Dialog, DialogActions, DialogTitle, DialogContent, IconButton, Typography, TextField, Chip, MenuItem } from '@mui/material';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { motion } from 'framer-motion';

const Templates = () => {
    const dispatch = useDispatch(); 
    const selector = useSelector(state=>state.template);
    const selectorAuth = useSelector(state=>state.auth);
    const [name, setname] = useState('')
    const [id, setid] = useState(0)
    const [open, setopen] = useState(false);
    const [message, setmessage] = useState('')
    const [variables, setvariables] = useState([]);
    const generateVaribles = (messageD='')=>{
      //    const dt = message.match(/(\b[A-Z][A-Z]+|\b[A-Z]\b)/g);
         const dt = messageD.match(/{([^}]*)}/g) ?? [];
      //    const temp = dt.filter(e=>{
      //      return !['{patient_name}','{appointment_date}','{appointment_time}','{appointment_duration}','{doctor_name}','{business_name}'].includes(e);
      //    })
         console.log();
         setvariables(dt?.map(e=>({variable:e,relate:  ['{patient_name}','{appointment_date}','{appointment_time}','{appointment_duration}','{doctor_name}','{business_name}'].includes(e)?e.replace('{','').replace('}','').replace('_',' '):''}))); 
      //    dt.forEach(e=>{
      //         setvariables(prev=>({...prev,e}))
      //         // e.localeCompare
      //     });
      }
      const editVarible = (target,value)=>{
          let newArr = [...variables]; // copying the old datas array
    // a deep copy is not needed as we are overriding the whole object below, and not setting a property of it. this does not mutate the state.
    newArr[target].relate = value; // replace e.target.value with whatever you want to change it to
  
    setvariables(newArr);
      } 
    useEffect(() => {
      if(selectorAuth.user.role !== 'super_admin'){
        getTemplatesByBusiness(dispatch);
        // console.log('here admin');
      }else{
        console.log('here business');
        getTemplates(dispatch);
      }
    }, []);

    const [deleteId, setdeleteId] = useState(0);

    
  return (
    <AppLayout>
    <Dialog
    open={Boolean(deleteId)}
    >
      <DialogTitle>Are you sure you want to delete template?</DialogTitle>
      <DialogActions>
        <Button>cancel</Button>
        <Button variant='contained' color='error' onClick={async()=>{
          await deleteTemplates(dispatch,deleteId);
          setdeleteId(0);
        }}>delete</Button>
      </DialogActions>
    </Dialog>
    <motion.div 
      className="w-full h-full flex flex-col items-start gap-4"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.3 }}
    >
      <Header
      title={'Templates'}
      actions={<>
  <Link to={"/admin/templates/add"}>
<IconButton onClick={()=>{
  
}}>
   <span
              onClick={() => {
              }}
              className="bg-primary text-center rounded-full text-white w-10 h-10 flex items-center justify-center"
              >
              <span className="-mt-1 text-2xl" >
              +
              </span>
            </span>
   </IconButton>
    </Link>    
      </>}
      />
      {/* <div className="flex justify-between w-full px-4">
        <h1 className="font-bold text-2xl">Templates</h1>
        <Link to={"/admin/templates/add"}>
          <button className="w-12 h-12 rounded-full">+</button>
        </Link>
      </div> */}
      <Dialog
        open={open}
        onClose={() => setopen(false)}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: '20px',
            background: 'rgba(255, 255, 255, 0.95)',
            backdropFilter: 'blur(20px)',
            maxHeight: '90vh',
          }
        }}
      >
        <DialogTitle sx={{ 
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          color: 'white',
          fontWeight: 700,
          fontSize: '1.5rem',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          py: 2
        }}>
          Edit Template
          <IconButton onClick={() => setopen(false)} sx={{ color: 'white' }}>
            <MdClose />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ p: 4 }}>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3 }}
            className='w-full flex flex-col gap-6'
          >
            <TextField
              fullWidth
              label="Template Name"
              placeholder='Template Name'
              value={name}
              onChange={e => setname(e.target.value)}
              variant="outlined"
              sx={{
                '& .MuiOutlinedInput-root': {
                  borderRadius: '12px',
                  backgroundColor: 'rgba(255, 255, 255, 0.95)',
                  backdropFilter: 'blur(10px)',
                  '&:hover': {
                    backgroundColor: 'rgba(255, 255, 255, 1)',
                    transform: 'translateY(-2px)',
                    boxShadow: '0 8px 25px rgba(102, 126, 234, 0.15)',
                  },
                  '&.Mui-focused': {
                    boxShadow: '0 8px 25px rgba(102, 126, 234, 0.25)',
                  },
                },
              }}
            />
            
            <TextField
              fullWidth
              multiline
              rows={6}
              label="Template Message"
              placeholder='Template Message'
              value={message}
              onChange={e => setmessage(e.target.value)}
              variant="outlined"
              sx={{
                '& .MuiOutlinedInput-root': {
                  borderRadius: '12px',
                  backgroundColor: 'rgba(255, 255, 255, 0.95)',
                  backdropFilter: 'blur(10px)',
                  '&:hover': {
                    backgroundColor: 'rgba(255, 255, 255, 1)',
                    transform: 'translateY(-2px)',
                    boxShadow: '0 8px 25px rgba(102, 126, 234, 0.15)',
                  },
                  '&.Mui-focused': {
                    boxShadow: '0 8px 25px rgba(102, 126, 234, 0.25)',
                  },
                },
              }}
            />
            
            <Button
              onClick={() => generateVaribles(message)}
              variant="contained"
              sx={{
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                borderRadius: '12px',
                py: 1.5,
                px: 4,
                textTransform: 'none',
                fontSize: '1rem',
                fontWeight: 600,
                '&:hover': {
                  background: 'linear-gradient(135deg, #764ba2 0%, #667eea 100%)',
                  transform: 'translateY(-2px)',
                  boxShadow: '0 8px 25px rgba(102, 126, 234, 0.3)',
                },
              }}
            >
              Generate Variables
            </Button>
            
            {variables.length > 0 && (
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 0.2 }}
                className='flex items-start flex-col gap-4 w-full bg-gray-50/50 rounded-xl p-6'
              >
                <h4 className='font-bold text-lg text-gray-800 mb-2'>Variable Mapping</h4>
                {variables.map((ele, i) => (
                  <motion.div
                    initial={{ opacity: 0, x: -20 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ delay: 0.3 + i * 0.1 }}
                    className='flex gap-4 w-full items-center' key={i}
                  >
                    <TextField
                      className='flex-1'
                      type='text'
                      disabled
                      value={ele.variable}
                      variant="outlined"
                      sx={{
                        '& .MuiOutlinedInput-root': {
                          borderRadius: '12px',
                          backgroundColor: 'rgba(255, 255, 255, 0.95)',
                        },
                      }}
                    />
                    {['{patient_name}', '{appointment_date}', '{appointment_time}', '{appointment_duration}', '{doctor_name}', '{business_name}'].includes(ele.variable) ? (
                      <Chip
                        label={ele.relate}
                        sx={{
                          backgroundColor: '#667eea',
                          color: 'white',
                          fontWeight: 600,
                          minWidth: '150px',
                        }}
                      />
                    ) : (
                      <TextField
                        select
                        className='flex-1'
                        onChange={ev => editVarible(i, ev.target.value)}
                        value={ele.relate}
                        variant="outlined"
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            borderRadius: '12px',
                            backgroundColor: 'rgba(255, 255, 255, 0.95)',
                          },
                        }}
                      >
                        <MenuItem value=''>Select Field</MenuItem>
                        <MenuItem value='Patient Name'>Patient Name</MenuItem>
                        <MenuItem value="Patient Phone">Patient Phone</MenuItem>
                        <MenuItem value="Staff Name">Staff Name</MenuItem>
                        <MenuItem value="Staff Phone">Staff Phone</MenuItem>
                        <MenuItem value="Start Date">Start Date</MenuItem>
                        <MenuItem value="End Date">End Date</MenuItem>
                        <MenuItem value="Start Time">Start Time</MenuItem>
                        <MenuItem value="End Time">End Time</MenuItem>
                        <MenuItem value="Service Name">Service Name</MenuItem>
                        <MenuItem value="Business Name">Business Name</MenuItem>
                        <MenuItem value="Business Phone">Business Phone</MenuItem>
                        <MenuItem value="Business Address">Business Address</MenuItem>
                      </TextField>
                    )}
                  </motion.div>
                ))}
              </motion.div>
            )}
            
            <div className='w-full'>
              <h4 className='font-bold text-lg text-gray-800 mb-4 text-center'>Predefined Dynamic Variables</h4>
              <div className='text-center w-full flex flex-wrap gap-3 justify-center'>
                {[
                  { label: 'Patient Name', var: '{patient_name}' },
                  { label: 'Appointment Date', var: '{appointment_date}' },
                  { label: 'Appointment Time', var: '{appointment_time}' },
                  { label: 'Appointment Duration', var: '{appointment_duration}' },
                  { label: 'Doctor Name', var: '{doctor_name}' },
                  { label: 'Business Name', var: '{business_name}' },
                ].map((item, idx) => (
                  <motion.div
                    key={idx}
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                  >
                    <Chip
                      label={item.label}
                      onClick={() => {
                        setmessage(prevMessage => prevMessage + item.var);
                      }}
                      sx={{
                        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                        color: 'white',
                        fontWeight: 600,
                        cursor: 'pointer',
                        '&:hover': {
                          background: 'linear-gradient(135deg, #764ba2 0%, #667eea 100%)',
                          transform: 'translateY(-2px)',
                          boxShadow: '0 4px 12px rgba(102, 126, 234, 0.3)',
                        },
                      }}
                    />
                  </motion.div>
                ))}
                    </div>
              <p className='text-gray-600 text-center w-full mt-4 text-sm'>
                Click on variables above to add them to your message template
              </p>
        </div>
          </motion.div>
        </DialogContent>
        <DialogActions sx={{ p: 3, pt: 0 }}>
          <Button
            onClick={() => setopen(false)}
            sx={{
              borderRadius: '12px',
              textTransform: 'none',
              px: 3,
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={() => {
              if (selectorAuth.user.role !== 'super_admin') {
                editTemplatesByBusiness(dispatch, {
       template_id: id,  
       template_name: name,
       template: message,
                  varibles: variables
                });
              } else {
                editTemplates(dispatch, {
        id,  
        name,
        message,
                  varibles: variables
                });
              }
              setopen(false);
            }}
            variant="contained"
            sx={{
              background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
              borderRadius: '12px',
              py: 1,
              px: 4,
              textTransform: 'none',
              fontSize: '1rem',
              fontWeight: 600,
              '&:hover': {
                background: 'linear-gradient(135deg, #764ba2 0%, #667eea 100%)',
                transform: 'translateY(-2px)',
                boxShadow: '0 8px 25px rgba(102, 126, 234, 0.4)',
              },
            }}
          >
            Save Changes
          </Button>
        </DialogActions>
      </Dialog>
      <div className="ag-theme-alpine" style={{ height: '500px', width: '100%', padding: '16px' }}>
        <AgGridReact
          rowData={selector?.templates || []}
          columnDefs={useMemo(() => {
            const cols = [];
            if (selectorAuth.user.role === 'super_admin') {
              cols.push({
                field: 'id',
                headerName: 'Id',
                width: 100
              });
            }
            cols.push(
              {
                field: selectorAuth.user.role !== 'super_admin' ? 'template_name' : 'name',
                headerName: 'Name',
                flex: 1,
                minWidth: 150
              },
              {
                field: selectorAuth.user.role !== 'super_admin' ? 'template' : 'message',
                headerName: 'Message',
                flex: 2,
                minWidth: 200
              },
              {
                field: 'actions',
                headerName: 'Actions',
                width: 150,
                cellRenderer: (params) => {
                  const data = params.data;
                  return (
                    <p className='flex items-center gap-2 justify-end'>
                      <IconButton size="small" onClick={() => {
                        setname(selectorAuth.user.role !== 'super_admin' ? data?.template_name : data?.name);
                        setmessage(selectorAuth.user.role !== 'super_admin' ? data?.template : data?.message);
                        generateVaribles(selectorAuth.user.role !== 'super_admin' ? data?.template : data?.message);
                        setid(selectorAuth.user.role !== 'super_admin' ? data?.template_id : data?.id);
                        setopen(true);
                      }}>
                        <MdEdit/>
                      </IconButton>
                      <IconButton size="small" onClick={() => {
                        if (selectorAuth.user.role === 'super_admin') {
                          setdeleteId(data?.id);
                        }
                      }}>
                        <MdDelete />
                      </IconButton>
                    </p>
                  );
                },
                sortable: false,
                filter: false
              }
            );
            return cols;
          }, [selectorAuth.user.role])}
          defaultColDef={useMemo(() => ({
            sortable: true,
            filter: true,
            resizable: true
          }), [])}
          pagination={true}
          paginationPageSize={10}
          animateRows={true}
        />
      </div>
      </motion.div>
    </AppLayout>
  )
}

export default Templates

//       <div className="table-wrapper">
//         <div className='table-container'>
//          <div className="td-head lg:w-full justify-between">
//             {
//               selectorAuth?.user?.role==='super_admin'??
//               <p className="td-element">Id</p>
//             }
//             <p className="td-element">Name</p>
//             <p className="td-element">Message</p>
//             {/* <p className="td-element">See Details</p> */}
//             <p className="td-element">Action</p>
//           </div>
//           <div className="flex-1">
//             {
//                 selector?.templates?.map(
//                     (e,i)=><div className='td-row lg:w-full justify-between' key={i}>
//                       {
//               selectorAuth?.user?.role==='super_admin'??
//                         <p className='td-element'>{selectorAuth.user.role !== 'super_admin'?e?.template_id:e?.id}</p>
//                       }
//                         <p className='td-element'>{selectorAuth.user.role !== 'super_admin'?e?.template_name:e?.name}</p>
//                         <p className='td-element'>{selectorAuth.user.role !== 'super_admin'?e?.template:e?.message}</p>
//                         {/* <p className='td-element'>{e?.staff_limit === 100000 ? 'Unlimited':e?.staff_limit}</p>
//                         <p className='td-element'>{e?.customer_limit === 100000 ? 'Unlimited':e?.customer_limit}</p>
//                         <p className='td-element'>{e?.storage_limit>1024? e?.storage_limit / 1024 : e?.storage_limit} {e?.storage_limit>1024? 'GB' : 'MB'}</p>
//                         <p className='td-element'>{e?.sms_limit === 100000 ? 'Unlimited':e?.sms_limit}</p> */}
//                         {/* <p className='td-element text-blue-500 underline'>
//                            <Link to={`/plans/${e?.id}`}>
//                            see
//                            </Link> 
//                         </p> */}
//                         <p className="td-element">
//                   <span className="flex gap-4 justify-center items-center">
//                     <AiFillEdit
//                     onClick={()=>{
//                       setname(selectorAuth.user.role !== 'super_admin'?e?.template_name:e?.name);
//                       setmessage(selectorAuth.user.role !== 'super_admin'?e?.template:e?.message);
//                       generateVaribles(selectorAuth.user.role !== 'super_admin'?e?.template:e?.message);
//                       setid(selectorAuth.user.role !== 'super_admin'?e?.template_id:e?.id);
//                       setopen(true);
//                     }}
//                       className="cursor-pointer"
//                       // onClick={setEditMode}
//                     />
// <MdDelete color='red' onClick={()=>{
//   if(selectorAuth.user.role === 'super_admin'){
//     setdeleteId(e?.id);
//   }else{

//   }
// }}/>
//                   </span>
//                 </p>
//                     </div>
//                 )
//             }
//           </div> 
//         </div>
//           </div>